import setSelectedInvoices from "@auer-steel/Store/Pages/InvoiceHistory/Handlers/SetSelectedInvoices";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, ClearSearch } from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/ClearSearch";

export type HandlerType = Parameters<typeof ClearSearch>[0];

addToChainBefore(chain, ClearSearch, ClearSelectedInvoices);

function ClearSelectedInvoices(props: HandlerType) {
    // AST-139
    props.dispatch(setSelectedInvoices([]));
}
